import { render, staticRenderFns } from "./PagerComponent.vue?vue&type=template&id=c3c813ec&scoped=true&"
import script from "./PagerComponent.vue?vue&type=script&lang=js&"
export * from "./PagerComponent.vue?vue&type=script&lang=js&"
import style0 from "./PagerComponent.vue?vue&type=style&index=0&id=c3c813ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c813ec",
  null
  
)

export default component.exports